import { hashString } from '../api/types';
import { LegacyDomainScopedStore, LegacyStore } from './legacy-types';

const getLegacyDomainScopedStoreDeps = (
  legacyDomainScopedStore: LegacyDomainScopedStore
) =>
  hashString([
    ...legacyDomainScopedStore.attritionStore.getDeps(),
    ...legacyDomainScopedStore.benchmarkStore.getDeps(),
    ...legacyDomainScopedStore.cachedAliasService.getDeps(),
    ...legacyDomainScopedStore.cachedMasterDataApiService.getDeps(),
    ...legacyDomainScopedStore.companySettingsStore.getDeps(),
    ...legacyDomainScopedStore.metricStore.getDeps(),
    ...legacyDomainScopedStore.reportStore.getDeps(),
    ...legacyDomainScopedStore.recruitmentStore.getDeps(),
    ...legacyDomainScopedStore.permissionsStore.getDeps(),
    ...legacyDomainScopedStore.masterDataApiService.getDeps(),
    ...legacyDomainScopedStore.exportStore.getDeps(),
    ...legacyDomainScopedStore.dashboardSettingsStore.getDeps(),
    ...legacyDomainScopedStore.evaluationStore.getDeps(),
    ...legacyDomainScopedStore.requestService.getDeps(),
    ...legacyDomainScopedStore.timeSliderStore.getDeps(),
    ...legacyDomainScopedStore.filterStore.getDeps(),
    ...legacyDomainScopedStore.forecastStore.getDeps(),
    ...legacyDomainScopedStore.loadingStateStore.getDeps(),
    ...legacyDomainScopedStore.dashboardStore.getDeps(),
    ...legacyDomainScopedStore.chartDescriptionStore.getDeps(),
    ...legacyDomainScopedStore.errorStore.getDeps(),
    ...legacyDomainScopedStore.peopleBalanceSheetStore.getDeps(),
    ...legacyDomainScopedStore.recruitmentBalanceSheetStore.getDeps(),
    ...legacyDomainScopedStore.surveyDashboardStore.getDeps(),
    ...legacyDomainScopedStore.surveyService.getDeps(),
    ...legacyDomainScopedStore.payrollStore.getDeps(),
  ]);
const getLegacyStoreDeps = (legacyStore: LegacyStore) =>
  hashString([
    ...legacyStore.userApiService.getDeps(),
    ...legacyStore.permissionService.getDeps(),
  ]);
export { getLegacyDomainScopedStoreDeps, getLegacyStoreDeps };
